
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#000","d":"M12.35 13.16c-1 0-1.54.58-3.25.58s-2.2-.58-3.24-.58A4.87 4.87 0 001 18v1.51a1.74 1.74 0 001.74 1.73h12.73a1.74 1.74 0 001.74-1.73V18a4.87 4.87 0 00-4.86-4.84h0z"}}),_c('circle',{attrs:{"cx":"9.1","cy":"7.37","r":"4.63","stroke":"#000"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M23 11.45v1.1a.55.55 0 01-.55.55h-2.19v2.19a.55.55 0 01-.55.55h-1.1a.55.55 0 01-.55-.55V13.1h-2.19a.55.55 0 01-.55-.55v-1.1a.55.55 0 01.55-.55h2.19V8.71a.55.55 0 01.55-.55h1.1a.55.55 0 01.55.55v2.19h2.19a.55.55 0 01.55.55z"}})])])
          )
        }
      }
    